<template lang="pug">
  div.page--account.page
    page-header.page-header--account(
      :breadcrumb-only="false"
      :page-title="trans('labels.frontend.account.profile.account')"
      header-class="page-header--account"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .container
      .row
        .col-lg-3.col-xl-2
          nav.navbar.navbar--account.navbar-expand-lg.p-0(
            data-toggle='collapse', data-target='#navbarAccount', aria-controls='navbarAccount', aria-expanded='false', aria-label='Toggle navigation'
          )
            a.navbar-brand(href='#').d-flex.d-lg-none {{ trans('labels.frontend.account.profile.account') }}
            button.navbar-toggler(type='button')
              span.navbar-toggler-icon
                font-awesome-icon(:icon=['far', 'bars'])
            #navbarAccount.collapse.navbar-collapse
              .navbar-nav.flex-column
                .account-navigation
                  ul.fa-ul
                    li
                      router-link(:to="{ name: 'account.orders' }", :title="trans('menus.frontend.navigation.orders')")
                        span.fa-li
                          font-awesome-icon(:icon="['far', 'list-alt']")
                        | {{ trans('menus.frontend.navigation.orders') }}
                    li
                      router-link(:to="{ name: 'account.payment-notify' }", :title="trans('menus.frontend.navigation.payment-notify')")
                        span.fa-li
                          font-awesome-icon(:icon="['far', 'comment-alt-dollar']")
                        | {{ trans('menus.frontend.navigation.payment-notify-short') }}
                    li
                      router-link(:to="{ name: 'account.profile' }", :title="trans('menus.frontend.navigation.account')")
                        span.fa-li
                          font-awesome-icon(:icon="['far', 'user']")
                        | {{ trans('menus.frontend.navigation.account') }}
                    li
                      router-link(:to="{ name: 'account.wishlist' }", :title="trans('menus.frontend.navigation.wishlist')")
                        span.fa-li
                          font-awesome-icon(:icon="['far', 'heart']")
                        | {{ trans('menus.frontend.navigation.wishlist') }}
                    li
                      router-link(:to="{ name: 'account.change-password' }", :title="trans('menus.frontend.navigation.change-password')")
                        span.fa-li
                          font-awesome-icon(:icon="['far', 'lock-alt']")
                        | {{ trans('menus.frontend.navigation.change-password') }}
                    li
                      a(@click.prevent="logout" :title="trans('navs.general.logout')" href="#logout")
                        span.fa-li
                          i.far.fa-sign-out
                        | {{ trans('navs.general.logout') }}
                .account-sub-navigation
                  h4.account-sub-navigation__title {{ trans('labels.frontend.footer.help') }}
                  ul.list-unstyled
                    li
                      router-link(:to="{ name: 'help.single', params: { slug: 'how-to-order' } }" :title="trans('menus.frontend.navigation.how-to-buy')")
                        | {{ trans('menus.frontend.navigation.how-to-buy') }}
                    li
                      router-link(:to="{ name: 'help.single', params: { slug: 'tracking' } }" :title="trans('menus.frontend.navigation.check-tracking')")
                        | {{ trans('menus.frontend.navigation.check-tracking') }}
                    li
                      router-link(:to="{ name: 'help.single', params: { slug: 'faqs' } }" :title="trans('menus.frontend.navigation.faqs')")
                        | {{ trans('menus.frontend.navigation.faqs') }}
                    li
                      router-link(:to="{ name: 'help.single', params: { slug: 'shipping' } }" :title="trans('menus.frontend.navigation.how-to-ship')")
                        | {{ trans('menus.frontend.navigation.how-to-ship') }}
                    li
                      router-link(:to="{ name: 'help.single', params: { slug: 'how-to-claim' } }" :title="trans('menus.frontend.navigation.how-to-claim')")
                        | {{ trans('menus.frontend.navigation.how-to-claim') }}
        .col-lg-9.col-xl-10.account-page
          .account-page__content
            transition(name="slide-up" mode="out-in")
              router-view
</template>

<script>
import PageHeader from '../../components/layouts/PageHeader.vue';
import notify from '../../components/notify';

export default {
  components: {
    PageHeader,
  },
  watch: {
    $route(val, oldVal) {
      if (val.path !== oldVal.path) {
        $('.navbar-collapse').collapse('hide');
      }
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/logout');
      notify.success(this, { title: Lang.get('alerts.frontend.general.logged_out'), text: '' });
    },
  },
};
</script>
